import React, { Component } from 'react'
import {getGameData, getUser, startGame, addQuestion, addPlayer} from '../functions/firebase'
import Loading from './componnets/Loading';
import Names from './componnets/Names'
import Question from './componnets/Question'
import Display from './componnets/Display';
import NotFound from './componnets/NotFound';


export default class Nakbah extends Component {
    state={
        link:'',
        player: '',
        status:'question',
        notfound:false
    }
    componentDidMount(){
        this.state.player =  getUser()
        getGameData(this.props.match.params.gameId, this.set)
        

    
     
    }
    set = data => { 
        this.setState({
            data
        })
        if(data){
            this.isadmin(data)  
            if(!this.state.playerAdded){
                addPlayer(this.props.match.params.gameId, this.state.player, data)
                this.setState({
                    playerAdded: true
                })
            }
        }else{ 
            this.setState({notfound:true })
        }
      
    } 
    isadmin = (data) => {
           data.names.forEach(element => { 
                if(element.id == this.state.player.uid)
                { 
                    console.log('found you');
                    if( element.admin == true) this.setState({isadmin:true})
                }
            });
        
    }

  
    addQuestion = (question) => {
        if(question){ 
            addQuestion(this.props.match.params.gameId, this.state.player, this.state.data, question)
            this.next('display')
        }else{
            alert('please type fill your question')
        }
    }
    next=(stat)=>{
        this.setState({
            status:stat
        })
    }
    render() {
        console.log(this.state);
        if(this.state.status === 'question' && this.state.data){
            this.state.data.questions.forEach(ques =>{
                if(this.state.player.uid === ques.player){ 
                    this.next('display')
                }
            } 
                )
        }

        return (
            <div>

                {this.state.data? 
    
                <div>

<Names data={this.state.data} gameId={this.props.match.params.gameId} isadmin={this.state.isadmin} />

<div className="containThis">


{this.state.status === 'question'? 
<Question isadmin={this.state.isadmin} addQues={this.addQuestion}/>
:'' }
{this.state.status === 'display'? 
<Display data={this.state.data} page={this.next} player={this.state.player} isadmin={this.state.isadmin} gameId={this.props.match.params.gameId}/>
:""}

</div>

                    </div>              
               : <>
               {this.state.notfound? 
                <NotFound />
                :
                <Loading/>}
                </>}
               
           </div>
        )
    }
}
